module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container_medio container_com-fundo container_com-margem u-padding-grande edicao-da-solicitacao-mcmv-cidades"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.abrirModalDeEdicao.apply(null, arguments)
      }
    }
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior grande"
  }, [_vm._v("Edição das informações de solicitação")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "u-padding-esquerda-grande u-margem-superior-media u-margem-inferior-grande"
  }, [_vm._l((_vm.solicitacao.Proponentes), function(proponente, index) {
    return _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n          " + _vm._s(index + 1) + "º Proponente\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal u-margem-inferior-media"
    }, [_c('div', {
      staticClass: "linha u-margem-superior-media"
    }, [_c('div', {
      staticClass: "field coluna"
    }, [_vm._m(1, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(2, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Telefone || 'NÃO INFORMADO'))])])])]), _vm._v(" "), (proponente.Conjuge) ? _c('div', [_c('span', {
      staticClass: "titulo titulo_pequeno"
    }, [_vm._v("\n            " + _vm._s(index + 1) + "º Cônjuge\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "field is-horizontal u-margem-inferior-grande"
    }, [_c('div', {
      staticClass: "linha u-margem-superior-pequena"
    }, [_c('div', {
      staticClass: "field coluna"
    }, [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Nome))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(5, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Cpf))])]), _vm._v(" "), _c('div', {
      staticClass: "field coluna"
    }, [_vm._m(6, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(proponente.Conjuge.Telefone || 'NÃO INFORMADO'))])])])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4 u-sem-padding"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Renda familiar comprovada*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.RendaFamiliarComprovada),
      expression: "solicitacao.RendaFamiliarComprovada"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input u-margem-superior-pequena",
    attrs: {
      "type": "text",
      "placeholder": "10.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.RendaFamiliarComprovada)
    },
    on: {
      "blur": _vm.validarEnquadramentoDaNovaRenda,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "RendaFamiliarComprovada", $event.target.value)
      }
    }
  })])])], 2), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "u-padding-esquerda-media"
  }, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Cidade")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Cidade),
      expression: "solicitacao.Cidade"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "cidade",
      "type": "text",
      "id": "cidade",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Cidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Cidade", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "matricula"
    }
  }, [_vm._v("Matrícula*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Matricula),
      expression: "solicitacao.Matricula"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "matricula",
      "type": "tel",
      "id": "matricula",
      "placeholder": "Somente números",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Matricula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Matricula", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("APF*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Apf),
      expression: "solicitacao.Apf"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "cep",
      "type": "tel",
      "id": "cep",
      "placeholder": "Somente números",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Apf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Apf", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_8"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Empreendimento*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Empreendimento),
      expression: "solicitacao.Empreendimento"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "tipo-de-empreendimento",
      "type": "text",
      "id": "tipo-de-empreendimento",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Empreendimento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Empreendimento", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Tipo do imóvel*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.TipoDeImovel),
      expression: "solicitacao.TipoDeImovel"
    }],
    staticClass: "formulario__input",
    attrs: {
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.solicitacao, "TipoDeImovel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.verificarSeImovelEhApartamento]
    }
  }, _vm._l((_vm.tiposDeImovel), function(tipoDeImovel) {
    return _c('option', {
      domProps: {
        "value": tipoDeImovel.Id,
        "selected": tipoDeImovel.Id === _vm.solicitacao.TipoDeImovel ? 'selected' : ''
      }
    }, [_vm._v("\n              " + _vm._s(tipoDeImovel.Nome) + "\n            ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_5"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Construtora")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ConstrutoraNome),
      expression: "solicitacao.ConstrutoraNome"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "nome-da-construtora",
      "type": "text",
      "id": "nome-da-construtora",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ConstrutoraNome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ConstrutoraNome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ConstrutoraCnpj),
      expression: "solicitacao.ConstrutoraCnpj"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "cpnj",
      "type": "text",
      "id": "cnpj",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ConstrutoraCnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ConstrutoraCnpj", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label"
  }, [_vm._v("Conta")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ConstrutoraConta),
      expression: "solicitacao.ConstrutoraConta"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "conta-da-construtora",
      "type": "text",
      "id": "conta-da-construtora",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ConstrutoraConta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ConstrutoraConta", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "tipo-do-logradouro"
    }
  }, [_vm._v("Tipo do logradouro*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.TipoDeLogradouroId),
      expression: "solicitacao.TipoDeLogradouroId"
    }],
    staticClass: "formulario__input",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.solicitacao, "TipoDeLogradouroId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tiposDeLogradouro), function(tipoDeLogradouro) {
    return _c('option', {
      domProps: {
        "value": tipoDeLogradouro.Id,
        "selected": tipoDeLogradouro.Id === _vm.solicitacao.TipoDeLogradouroId ? 'selected' : ''
      }
    }, [_vm._v("\n              " + _vm._s(tipoDeLogradouro.Nome) + "\n            ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_6"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "logradouro"
    }
  }, [_vm._v("Logradouro*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Logradouro),
      expression: "solicitacao.Logradouro"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "logradouro",
      "type": "text",
      "maxlenght": "90",
      "name": "logradouro",
      "placeholder": "Ex: Afonso Pena, da Divisão, Lídia Baís, etc.",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Logradouro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Logradouro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "numero"
    }
  }, [_vm._v("Número*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Numero),
      expression: "solicitacao.Numero"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "numero",
      "type": "number",
      "placeholder": "EX: 481",
      "number": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Numero", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Cep),
      expression: "solicitacao.Cep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('99999-999'),
      expression: "'99999-999'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "cep",
      "type": "tel",
      "id": "cep",
      "placeholder": "Somente números",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Cep", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "bairro"
    }
  }, [_vm._v("Bairro*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Bairro),
      expression: "solicitacao.Bairro"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "bairro",
      "name": "bairro",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: Centro, Santa Fé, Vila Carvalho...",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.Bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Bairro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_1"
  }, [(_vm.solicitacao.EhApartamento) ? _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "bloco"
    }
  }, [_vm._v("Bloco* ")]) : _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "quadra"
    }
  }, [_vm._v("Quadra*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.BlocoOuQuadra),
      expression: "solicitacao.BlocoOuQuadra"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "quadra",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: 1",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.BlocoOuQuadra)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "BlocoOuQuadra", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_1"
  }, [(_vm.solicitacao.EhApartamento) ? _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "apartamento"
    }
  }, [_vm._v("Ap*\n          ")]) : _c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "lote"
    }
  }, [_vm._v("Lote*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ApartamentoOuLote),
      expression: "solicitacao.ApartamentoOuLote"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "lote",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: A",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ApartamentoOuLote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ApartamentoOuLote", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "complemento"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.Complemento),
      expression: "solicitacao.Complemento"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "complemento",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: Casa 2"
    },
    domProps: {
      "value": (_vm.solicitacao.Complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "Complemento", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "u-padding-esquerda-media"
  }, [_c('div', {}, [_c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-da-compra-e-venda"
    }
  }, [_vm._v("\n              Valor de compra e venda*\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ValorDaCompraEVenda),
      expression: "solicitacao.ValorDaCompraEVenda"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "valor-da-compra-e-venda",
      "type": "text",
      "placeholder": "130.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ValorDaCompraEVenda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ValorDaCompraEVenda", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-do-financiamento-aprovado"
    }
  }, [_vm._v("Valor do financiamento*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ValorDoFinanciamentoAprovado),
      expression: "solicitacao.ValorDoFinanciamentoAprovado"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "valor-do-financiamento-aprovado",
      "type": "text",
      "placeholder": "90.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ValorDoFinanciamentoAprovado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ValorDoFinanciamentoAprovado", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "subsidio-governo-federal"
    }
  }, [_vm._v("Subsídio do Governo Federal*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.SubsidioDoGovernoFederal),
      expression: "solicitacao.SubsidioDoGovernoFederal"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "subsidio-governo-federal",
      "type": "text",
      "placeholder": "14.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.SubsidioDoGovernoFederal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "SubsidioDoGovernoFederal", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "valor-de-avaliacao"
    }
  }, [_vm._v("Valor de avaliação*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ValorDeAvaliacao),
      expression: "solicitacao.ValorDeAvaliacao"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "valor-de-avaliacao",
      "type": "text",
      "placeholder": "130.000,00",
      "required": ""
    },
    domProps: {
      "value": (_vm.solicitacao.ValorDeAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ValorDeAvaliacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "data-de-avaliacao"
    }
  }, [_vm._v("Data de avaliação*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.DataDeAvaliacao),
      expression: "solicitacao.DataDeAvaliacao"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "data-de-avaliacao",
      "type": "date",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.DataDeAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "DataDeAvaliacao", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "codigo-de-avaliacao"
    }
  }, [_vm._v("Código de avaliação*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.CodigoDeAvaliacao),
      expression: "solicitacao.CodigoDeAvaliacao"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "codigo-de-avaliacao",
      "type": "number",
      "placeholder": "Somente números",
      "number": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.CodigoDeAvaliacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "CodigoDeAvaliacao", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "grade__linha"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "desconto-da-construtora"
    }
  }, [_vm._v("Desconto da construtora na entrada")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.DescontoConstrutora),
      expression: "solicitacao.DescontoConstrutora"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "desconto-da-construtora",
      "type": "text",
      "placeholder": "10.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.DescontoConstrutora)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "DescontoConstrutora", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "participacao-necessaria"
    }
  }, [_vm._v("Participação do proponente*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.ParticipacaoDoSolicitante),
      expression: "solicitacao.ParticipacaoDoSolicitante"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('money'),
      expression: "'money'"
    }],
    staticClass: "formulario__input",
    attrs: {
      "id": "participacao-necessaria",
      "type": "text",
      "placeholder": "10.000,00"
    },
    domProps: {
      "value": (_vm.solicitacao.ParticipacaoDoSolicitante)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "ParticipacaoDoSolicitante", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    staticClass: "formulario__label",
    attrs: {
      "for": "subsidio-solicitado-agehab"
    }
  }, [_vm._v("Subsídio solicitado AGEHAB*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.SubsidioDaAgehab),
      expression: "solicitacao.SubsidioDaAgehab"
    }],
    staticClass: "formulario__input",
    attrs: {
      "name": "valorDoSubsidioDaAgehab",
      "type": "text",
      "id": "valorDoSubsidioDaAgehab",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.solicitacao.SubsidioDaAgehab)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao, "SubsidioDaAgehab", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-horizontal-direita u-margem-superior-grande"
  }, [_c('router-link', {
    staticClass: "botao botao_cinza botao_medio",
    class: {
      'is-disabled': _vm.loading.visivel
    },
    attrs: {
      "to": {
        name: 'DetalhesDaSolicitacaoParaMcmvCidades',
        query: {
          idDaSolicitacao: this.$route.query.idDaSolicitacao
        }
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-terciaria u-margem-esquerda-media",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Avançar")])], 1)]), _vm._v(" "), (_vm.modalDeIndeferimentoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeIndeferimento
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.cancelarSolicitacao.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Edição das informações da solicitação")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-horizontal-centro u-margem-inferior-media"
  }, [_c('div', {
    staticClass: "grade__coluna mensagem mensagem_cor-atencao u-sem-margem",
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "far fa-exclamation-circle mensagem__icone"
  }), _vm._v(" "), _c('div', {
    staticClass: "mensagem__conteudo"
  }, [_c('h2', {
    staticClass: "mensagem__titulo"
  }, [_vm._v("Fique atento:")]), _vm._v(" "), _c('p', {
    staticClass: "mensagem__texto mensagem-cancelamento"
  }, [_vm._v("A renda familiar comprovada foi editada e não se encaixa\n              na mesma faixa. Ao\n              completar essa ação, a solicitação será indeferida.")])])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mensagem-confirmacao u-margem-inferior-media"
  }, [_c('strong', [_vm._v("Tem certeza que deseja editar as informações?")])])]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeIndeferimento
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Confirmar")])])])]) : _vm._e(), _vm._v(" "), (_vm.modalDeEdicaoEstaVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModalDeEdicao
    }
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.editarSolicitacao.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "titulo titulo_medio u-margem-inferior-media"
  }, [_vm._v("Edição das informações da solicitação")]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-grande"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "mensagem-confirmacao u-margem-inferior-grande"
  }, [_c('strong', [_vm._v("Tem certeza que deseja editar as informações?")])])]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha_alinhar-horizontal-direita formulario-button"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_medio u-margem-direita-pequena",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModalDeEdicao
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    class: {
      'is-loading': _vm.loading.visivel
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Confirmar")])])])]) : _vm._e(), _vm._v(" "), _c('MensagemFlutuante', {
    attrs: {
      "mensagemVisivel": _vm.mensagemVisivel,
      "titulo": _vm.tituloMensagem,
      "estilo": _vm.estiloMensagem,
      "texto": _vm.textoMensagem
    },
    on: {
      "close": _vm.fecharMensagem
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-grande"
  }, [_c('i', {
    staticClass: "fal fa-user icone-de-titulo u-margem-direita-pequena"
  }), _vm._v(" Dados do proponente\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Nome:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("CPF:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "label"
  }, [_c('strong', [_vm._v("Telefone: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-grande"
  }, [_c('i', {
    staticClass: "fal fa-home negrito icone-de-titulo u-margem-direita-pequena"
  }), _vm._v(" Dados do imóvel\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "subtitle is-5 titulo-com-bordas-arredondas titulo-negrito u-padding-esquerdo-media u-margem-superior-grande"
  }, [_c('i', {
    staticClass: "fal fa-sack-dollar icone-de-titulo u-margem-direita-pequena"
  }), _vm._v(" Dados do financiamento\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha u-padding-esquerda-pequena"
  }, [_c('p', {
    staticClass: "u-margem-inferior-pequena titulo-negrito"
  }, [_c('strong', [_vm._v(" Recursos Próprios ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67ed7037"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacao-de-subsidio/McmvCidades/EditarValoresDaSolicitacaoParaMcmvCidades.vue
// module id = 1122
// module chunks = 1